export default __webpack_public_path__ + "static/media/gluten&lactosefree.75f706c0.png";